/*
 * Order Messages
 *
 * This contains all the text for the Order container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.Order";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Order",
  },

  headerTitle: {
    id: `${scope}.headerTitle`,
    defaultMessage: "Order Product",
  },
  summaryThanks: {
    id: `${scope}.summaryThanks`,
    defaultMessage: "Thanks for your order!",
  },
  summaryNote: {
    id: `${scope}.summaryNote`,
    defaultMessage:
      "* This date is indicative and can be changed by possible adjustments. If you want to make changes to your order afterwards, please contact us!",
  },
  summaryBack: {
    id: `${scope}.summaryBack`,
    defaultMessage: "Back to dashboard",
  },
  doOrder: {
    id: `${scope}.doOrder`,
    defaultMessage: "Make order",
  },
  finishOrderLater: {
    id: `${scope}.finishOrderLater`,
    defaultMessage: "Finish order later",
  },
  first_step: {
    id: `${scope}.first_step`,
    defaultMessage: "Patient",
  },
  second_step: {
    id: `${scope}.second_step`,
    defaultMessage: "Behandelplan",
  },
  third_step: {
    id: `${scope}.third_step`,
    defaultMessage: "Opties",
  },
  fourth_step: {
    id: `${scope}.fourth_step`,
    defaultMessage: "Klinische input",
  },

  teeth: {
    id: `${scope}.teeth`,
    defaultMessage: "Teeth",
  },

  implant: {
    id: `${scope}.implant`,
    defaultMessage: "en",
  },

  previous: {
    id: `${scope}.previous`,
    defaultMessage: "Previous",
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: "Next",
  },
  save_order: {
    id: `${scope}.save_order`,
    defaultMessage: "Save changes",
  },
  attention_order_not_finished: {
    id: `${scope}.attention_order_not_finished`,
    defaultMessage: "Attention: Order not placed yet!",
  },
  close_order_modal_message: {
    id: `${scope}.close_order_modal_message`,
    defaultMessage:
      'You leave the ordering process. Click "X" to return to the order. To continue you can "Do not save" or "Save" the current order.',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: "Continue",
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: "Save",
  },
  not_save: {
    id: `${scope}.not_save`,
    defaultMessage: "Do not save",
  },
  header_info_title: {
    id: `${scope}.header_info_title`,
    defaultMessage: "The order {caseId} has been filled in.",
  },
  header_info_subtitle: {
    id: `${scope}.header_info_subtitle`,
    defaultMessage:
      "Check all order data and fill in where possible. You can finish the order later or submit it.",
  },
  shipping: {
    id: `${scope}.shipping`,
    defaultMessage: "Shipping",
  },
  shippingData: {
    id: `${scope}.shippingData`,
    defaultMessage: "Shipping",
  },
  homeTreatment: {
    id: `${scope}.homeTreatment`,
    defaultMessage: "Home treatment",
  },
  homeTreatmentInfo: {
    id: `${scope}.homeTreatmentInfo`,
    defaultMessage:
      "The delivery address will be determined by ReFrezh based on the available information and the practitioner",
  },
});
